// The reset row: shown while search or a filter is active, it clears both in one step.

import React from 'react'

import { Button } from '@CommonComponents/buttons'
import { useTable } from '../context'

export const ResetRow = () => {
  const { clearQuery } = useTable()
  return (
    <div className="me-table-reset-row">
      <Button
        className="me-btn me-btn-ghost me-btn-sm"
        onClick={() => clearQuery()}
      >
        Clear search and filters
      </Button>
    </div>
  )
}
